import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { GetStatusRegister, saveStatusRegister } from "./index";

// Api's
import { statusRegisterApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getStatusRegisterSaga(action: GetStatusRegister) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(
			statusRegisterApi.getDomain,
			action.payload.showPending,
		);

		if (response.data.result) {
			yield put(saveStatusRegister(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveStatusRegister(null, true, resultError.messagesDataError));
		}
	}
}
